import React from 'react'

const MinimalisticTrashCanIcon = props => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.6875 0.9375C4.6875 0.42 5.03672 0 5.46875 0H8.59375C9.02578 0 9.375 0.42 9.375 0.9375C9.375 1.455 9.02578 1.875 8.59375 1.875H5.46875C5.03672 1.875 4.6875 1.455 4.6875 0.9375ZM3.75 13.125H10.3125V4.6875H3.75V13.125ZM11.25 2.8125H2.8125H0.9375C0.419062 2.8125 0 3.2325 0 3.75C0 4.2675 0.419062 4.6875 0.9375 4.6875H1.875V14.0625C1.875 14.58 2.29406 15 2.8125 15H11.25C11.7684 15 12.1875 14.58 12.1875 14.0625V4.6875H13.125C13.6434 4.6875 14.0625 4.2675 14.0625 3.75C14.0625 3.2325 13.6434 2.8125 13.125 2.8125H11.25Z"
      fill="#7F8FA4"
    />
  </svg>
)

export default MinimalisticTrashCanIcon



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/minimalisticTrashCan.js